import React from "react";
import "./Process.css";
import { IMAGES } from "../../utils/imageAssets";

interface ProcessProps {
  onSamplePDFClick: () => void;
}

const Process: React.FC<ProcessProps> = ({ onSamplePDFClick }) => {
  return (
    <section id="process-section" className="process-section">
      <div className="process-container">
        <div className="section-meta section-meta--orange">이용 과정</div>
        <h2 className="section-title">쉽고 빠른 3단계 스토리북 완성 워크플로우</h2>
        <div className="process-grid">
          {/* 과정 1 */}
          <div className="process-card">
            <div className="process-image-placeholder">
              <img
                src={IMAGES.STEPS.STEP_1}
                alt="오늘의 에피소드 선택 UI"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "220px",
                  objectFit: "contain",
                }}
              />
            </div>
            <div className="process-content">
              <p className="process-step">STEP 01</p>
              <h3 className="process-title">오늘의 에피소드 선택</h3>
              <ul className="process-description">
                <li>스토리북 작성에 최적화된 에피소드 구성</li>
                <li>시니어에 맞춘 글자 크기, 버튼 등 유니버설 디자인 적용</li>
              </ul>
            </div>
          </div>

          {/* 과정 2 */}
          <div className="process-card">
            <div className="process-image-placeholder">
              <img
                src={IMAGES.STEPS.STEP_2}
                alt="AI 서랍이와 대화 UI"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "220px",
                  objectFit: "contain",
                }}
              />
            </div>
            <div className="process-content">
              <p className="process-step">STEP 02</p>
              <h3 className="process-title">AI '서랍이'와 대화</h3>
              <ul className="process-description">
                <li>음성 및 화상 전화 형태로 시니어에 익숙한 UX</li>
                <li>음성과 텍스트를 같이 사용해 인터뷰 질문</li>
                <li>AI의 말하기 속도, 음량을 시니어에 최적화</li>
              </ul>
            </div>
          </div>

          {/* 과정 3 */}
          <div className="process-card">
            <div className="process-image-placeholder">
              <img
                src={IMAGES.STEPS.STEP_3}
                alt="스토리북 완성본 UI"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "220px",
                  objectFit: "contain",
                }}
              />
            </div>
            <div className="process-content">
              <p className="process-step">STEP 03</p>
              <h3 className="process-title">스토리북 완성</h3>
              <ul className="process-description">
                <li>20회 에피소드를 모아 스토리북 책으로 완성</li>
                <li>책, 오디오북, 영상 인터뷰 형태로 제공</li>
              </ul>
              <a
                className="process-sample-btn"
                onClick={onSamplePDFClick}
                style={{ display: "none" }} // FIXME: 샘플 스토리북 보기 error 발생, 버튼 숨김 처리 2025-11-06(목) 11:20
              >
                샘플 스토리북 보기 →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
